
  import missions from '~/mixins/pages/mission-control/missions'
  export default {
    name: 'Theme2MissionDesktopDailyActivityMission',
    mixins: [missions],
    props: {
      missionDate: {
        type: String,
        default: ''
      },
      activities: {
        type: Array,
        default: () => {}
      },
      cardTitle: {
        type: String,
        default: ''
      },
      cols: {
        type: String,
        default: '3'
      },
      mobileCols: {
        type: String,
        default: '6'
      },
      missionId: {
        type: String,
        default: ''
      },
      isExtraCoin: {
        type: Boolean,
        default: false
      }
    }
  }
